class AAWorkspaceShell {
  constructor(root) {
  this.root = root;
  this.toggle = root.querySelector('[data-aa-menu-toggle]');
  this.overlay = root.querySelector('[data-aa-overlay]');
  this.sidebar = root.querySelector('[data-aa-sidebar]');

  this.previousPlaybooks = [];
  this.previousPlaybookSearch = '';
  this.previousPlaybookSort = 'newest';
  this.clientAccount = null;
  this.clientConfiguration = null;

  this.catalogRecords = [];
  this.catalogLoadError = null;
  this.catalogYearFilter = '';
  this.catalogBrandFilter = '';

  this.marketingPlan = null;
  this.marketingPackage = null;
  this.contracts = null;
  this.brandAssets = null;

  this.init();
}

   async init() {
  

  this.bindEvents();
  this.bindCreatePlaybook();
  this.bindCatalogFilters();

  

  const adminClientId =
    await window.AAAdminWorkspaceView
      ?.getAuthorizedClientId?.();

  await window.AAWorkspaceContext.start({
    clientId: adminClientId || undefined
  });

  window.AAAdminWorkspaceView
    ?.enhanceWorkspace?.();

  

  const workspace = window.AAWorkspaceContext.get();
  

  if (!workspace?.user || workspace?.authLocked) {
    
    window.AAWorkspaceContext.redirectToLogin();
    return;
  }

  this.renderAccountIdentity();

 

await Promise.all([
  this.loadClientAccount(),
  this.loadClientModules()
]);


this.renderClientName();

await window.AAEmailWorkspace?.init?.({
  root: this.root,
  clientId: workspace.clientId,
  enabled: this.hasClientEmailModule()
});

await this.loadCatalogHistory();

  await this.loadDashboard();

  await this.loadMarketingPlan();

  await this.loadMarketingPackage();

  await this.loadContractCenter();

  await this.loadBrandAssets();

  await this.loadAccount();

  await this.loadPreviousPlaybooks();

}

async loadClientAccount() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId || !window.AAPlaybookService) return null;

  this.clientAccount = await window.AAPlaybookService.getClientAccount({
    clientId: workspace.clientId
  });

  const clientName =
    this.clientAccount?.business_name ||
    this.clientAccount?.client_name ||
    'Client Workspace';

  window.AA_WORKSPACE.clientName = clientName;

  return this.clientAccount;
}

renderClientName() {
  const workspace = window.AAWorkspaceContext.get();
  const clientName = workspace?.clientName || 'Client Workspace';

  this.root.querySelectorAll('[data-aa-client-name]').forEach((el) => {
    el.textContent = clientName;
  });
}

escapeCatalogHtml(value = '') {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

hasClientEmailModule() {
  const access = Array.isArray(this.clientConfiguration?.access)
    ? this.clientConfiguration.access
    : [];

  return access.some(
    (item) =>
      String(item).trim().toLowerCase() === 'email'
  );
}

hasClientCatalogService() {
  const services = Array.isArray(this.clientConfiguration?.services)
    ? this.clientConfiguration.services
    : [];

  return services.some((service) =>
    String(service)
      .trim()
      .toLowerCase()
      .includes('catalog')
  );
}

hasClientCatalogModule() {
  return (
    this.hasClientCatalogService() ||
    this.catalogRecords.length > 0
  );
}

async loadClientModules() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId) {
    return;
  }

  try {
    if (window.AASupabaseClient?.getClientConfiguration) {
      this.clientConfiguration =
        await window.AASupabaseClient.getClientConfiguration({
          clientId: workspace.clientId
        });
    }
  } catch (error) {
    console.error(
      'Unable to load client module configuration:',
      error
    );

    this.clientConfiguration = null;
  }

  try {
    if (!window.AASupabaseClient?.getCatalogRecords) {
      throw new Error(
        'Catalog history service is unavailable.'
      );
    }

    /*
     * SECURITY:
     * Catalog client ID comes only from AAWorkspaceContext.
     * It is never accepted from filters, links, DOM state,
     * query-string filter values, or catalog cards.
     */
    this.catalogRecords =
      await window.AASupabaseClient.getCatalogRecords({
        clientId: workspace.clientId
      });

    this.catalogLoadError = null;
  } catch (error) {
    console.error(
      'Unable to load client catalog history:',
      error
    );

    this.catalogRecords = [];
    this.catalogLoadError = error;
  }

  this.renderClientModuleNavigation();
}

renderClientModuleNavigation() {
  const nav =
    this.root.querySelector('[data-aa-client-module-nav]');

  if (!nav) {
    return;
  }

  const currentPath =
    window.location.pathname.replace(/\/+$/, '');

  const workspace =
    window.AAWorkspaceContext.get();

  const adminClientId =
    workspace?.isInternal
      ? window.AAAdminWorkspaceView?.getClientId?.()
      : null;

  const adminQuery =
    adminClientId
      ? `?aa_admin_client=${encodeURIComponent(adminClientId)}`
      : '';

  const dashboardUrl =
    `/pages/workspace-dashboard${adminQuery}`;

  const catalogsUrl =
    `/pages/workspace-catalogs${adminQuery}`;

  const emailUrl =
    `/pages/workspace-email${adminQuery}`;

  const links = [];

  if (this.hasClientCatalogModule()) {
    links.push(`
      <a
        href="${catalogsUrl}"
        class="aa-workspace__nav-link ${
          currentPath === '/pages/workspace-catalogs'
            ? 'is-active'
            : ''
        }"
        data-aa-client-catalog-nav
      >
       <span>Catalogs & Co-op</span>
      </a>
    `);
  }

  if (this.hasClientEmailModule()) {
    links.push(`
      <a
        href="${emailUrl}"
        class="aa-workspace__nav-link ${
          currentPath === '/pages/workspace-email'
            ? 'is-active'
            : ''
        }"
        data-aa-client-email-nav
      >
        <span>Email</span>
      </a>
    `);
  }

  nav.innerHTML = links.join('');

  const emailModule =
    this.root.querySelector('[data-aa-email-module]');

  if (emailModule) {
    emailModule.hidden =
      !this.hasClientEmailModule();
  }

  if (
    currentPath === '/pages/workspace-catalogs' &&
    !this.hasClientCatalogModule() &&
    !this.catalogLoadError
  ) {
    window.location.replace(dashboardUrl);
    return;
  }

  if (
    currentPath === '/pages/workspace-email' &&
    !this.hasClientEmailModule()
  ) {
    window.location.replace(dashboardUrl);
  }
}

bindCatalogFilters() {
  this.root.addEventListener('change', (event) => {
    const yearFilter =
      event.target.closest('[data-aa-catalog-year]');

    const brandFilter =
      event.target.closest('[data-aa-catalog-brand]');

    if (!yearFilter && !brandFilter) {
      return;
    }

    if (yearFilter) {
      this.catalogYearFilter = yearFilter.value;
    }

    if (brandFilter) {
      this.catalogBrandFilter = brandFilter.value;
    }

    this.renderCatalogRecords();
  });
}

getCatalogYear(record) {
  const value = String(record?.catalog_month || '');

  return /^\d{4}/.test(value)
    ? value.slice(0, 4)
    : '';
}

formatCatalogMonth(value) {
  if (!value) {
    return '';
  }

  const [year, month] =
    String(value).split('-').map(Number);

  if (!year || !month) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(Date.UTC(year, month - 1, 1))
  );
}

formatCatalogPublicationDate(value) {
  if (!value) {
    return '';
  }

  const parts = String(value)
    .slice(0, 10)
    .split('-')
    .map(Number);

  if (
    parts.length !== 3 ||
    !parts[0] ||
    !parts[1] ||
    !parts[2]
  ) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(
      Date.UTC(
        parts[0],
        parts[1] - 1,
        parts[2]
      )
    )
  );
}

formatCatalogViews(value) {
  const number = Number(value);

  if (!Number.isFinite(number) || number < 0) {
    return '';
  }

  return `${new Intl.NumberFormat('en-US').format(number)} views`;
}

populateCatalogFilters() {
  const yearSelect =
    this.root.querySelector('[data-aa-catalog-year]');

  const brandSelect =
    this.root.querySelector('[data-aa-catalog-brand]');

  const years = [
    ...new Set(
      this.catalogRecords
        .map((record) => this.getCatalogYear(record))
        .filter(Boolean)
    )
  ].sort((a, b) => Number(b) - Number(a));

  const brands = [
    ...new Set(
      this.catalogRecords.flatMap((record) =>
        Array.isArray(record.brands)
          ? record.brands
              .map((brand) => String(brand).trim())
              .filter(Boolean)
          : []
      )
    )
  ].sort((a, b) =>
    a.localeCompare(b, undefined, {
      sensitivity: 'base'
    })
  );

  if (yearSelect) {
    yearSelect.innerHTML = `
      <option value="">All Years</option>

      ${years.map((year) => `
        <option
          value="${this.escapeCatalogHtml(year)}"
          ${
            this.catalogYearFilter === year
              ? 'selected'
              : ''
          }
        >
          ${this.escapeCatalogHtml(year)}
        </option>
      `).join('')}
    `;
  }

  if (brandSelect) {
    brandSelect.innerHTML = `
      <option value="">All Brands</option>

      ${brands.map((brand) => `
        <option
          value="${this.escapeCatalogHtml(brand)}"
          ${
            this.catalogBrandFilter === brand
              ? 'selected'
              : ''
          }
        >
          ${this.escapeCatalogHtml(brand)}
        </option>
      `).join('')}
    `;
  }
}

async loadCatalogHistory() {
  const container =
    this.root.querySelector('[data-aa-catalog-history]');

  if (!container) {
    return;
  }

  if (this.catalogLoadError) {
    container.innerHTML = `
      <div class="aa-client-catalog-state">
        We couldn't load your catalogs right now.
        Please try again later.
      </div>
    `;

    return;
  }

  this.populateCatalogFilters();
  this.renderCatalogRecords();
}

renderCatalogRecords() {
  const container =
    this.root.querySelector('[data-aa-catalog-history]');

  if (!container) {
    return;
  }

  const selectedBrand =
    String(this.catalogBrandFilter || '')
      .trim()
      .toLowerCase();

  const records = this.catalogRecords.filter((record) => {
    const yearMatches =
      !this.catalogYearFilter ||
      this.getCatalogYear(record) ===
        this.catalogYearFilter;

    const brands = Array.isArray(record.brands)
      ? record.brands
      : [];

    const brandMatches =
      !selectedBrand ||
      brands.some(
        (brand) =>
          String(brand)
            .trim()
            .toLowerCase() === selectedBrand
      );

    return yearMatches && brandMatches;
  });

  if (!records.length) {
    container.innerHTML = `
      <div class="aa-client-catalog-state">
        No catalogs are available yet.
      </div>
    `;

    return;
  }

  container.innerHTML = records.map((catalog) => {
    const brands = Array.isArray(catalog.brands)
      ? catalog.brands
          .map((brand) => String(brand).trim())
          .filter(Boolean)
      : [];

    const title =
      catalog.catalog_title || 'Catalog';

    const month =
      this.formatCatalogMonth(
        catalog.catalog_month
      );

    const publicationDate =
      this.formatCatalogPublicationDate(
        catalog.publication_date
      );

    const views =
      this.formatCatalogViews(
        catalog.catalog_views
      );

    const cover =
      String(catalog.cover_image_url || '').trim();

    const catalogUrl =
      String(catalog.catalog_url || '').trim();

    return `
      <article class="aa-client-catalog-card">

        <div class="aa-client-catalog-card__cover">
          ${
            cover
              ? `
                <img
                  src="${this.escapeCatalogHtml(cover)}"
                  alt="${this.escapeCatalogHtml(title)} cover"
                  loading="lazy"
                  data-aa-catalog-cover-image
                >

                <div
                  class="aa-client-catalog-card__placeholder"
                  data-aa-catalog-cover-placeholder
                  hidden
                >
                  Catalog
                </div>
              `
              : `
                <div
                  class="aa-client-catalog-card__placeholder"
                >
                  Catalog
                </div>
              `
          }
        </div>

        <div class="aa-client-catalog-card__body">

          ${
            month
              ? `
                <p class="aa-client-catalog-card__month">
                  ${this.escapeCatalogHtml(month)}
                </p>
              `
              : ''
          }

          <h3>
            ${this.escapeCatalogHtml(title)}
          </h3>

          ${
            publicationDate
              ? `
                <p class="aa-client-catalog-card__published">
                  Published ${this.escapeCatalogHtml(publicationDate)}
                </p>
              `
              : ''
          }

          ${
            views
              ? `
                <p class="aa-client-catalog-card__views">
                  ${this.escapeCatalogHtml(views)}
                </p>
              `
              : ''
          }

          ${
            brands.length
              ? `
                <div
                  class="aa-client-catalog-card__brands"
                  aria-label="Brands represented"
                >
                  ${brands.map((brand) => `
                    <span class="aa-client-catalog-brand">
                      ${this.escapeCatalogHtml(brand)}
                    </span>
                  `).join('')}
                </div>
              `
              : ''
          }

          ${
            catalogUrl
              ? `
                <a
                  class="aa-button aa-button--small"
                  href="${this.escapeCatalogHtml(catalogUrl)}"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Catalog
                </a>
              `
              : ''
          }

        </div>
      </article>
    `;
  }).join('');

  container
    .querySelectorAll('[data-aa-catalog-cover-image]')
    .forEach((image) => {
      image.addEventListener('error', () => {
        image.hidden = true;

        const placeholder =
          image.parentElement?.querySelector(
            '[data-aa-catalog-cover-placeholder]'
          );

        if (placeholder) {
          placeholder.hidden = false;
        }
      });
    });
}

renderAccountIdentity() {
  const workspace = window.AAWorkspaceContext.get();
  const user = workspace?.user;

  if (!user) return;

  const metadata = user.user_metadata || {};

  const email =
    user.email ||
    '';

  const fallbackName =
    email
      ? email.split('@')[0]
      : 'Account';

  const name =
    metadata.full_name ||
    metadata.name ||
    metadata.display_name ||
    metadata.first_name ||
    fallbackName;

  const roleLabels = {
    aa_admin: 'AA Admin',
    aa_team: 'AA Team',
    client_owner: 'Client Owner',
    client_employee: 'Client Employee'
  };

  let role =
    roleLabels[workspace.role] ||
    workspace.role ||
    'Workspace User';

  const adminClientId =
    window.AAAdminWorkspaceView?.getClientId?.();

  if (workspace.isInternal && adminClientId) {
    role = `${role} · Admin View`;
  }

  const nameEl =
    this.root.querySelector('[data-aa-workspace-user-name]');

  const emailEl =
    this.root.querySelector('[data-aa-workspace-user-email]');

  const roleEl =
    this.root.querySelector('[data-aa-workspace-user-role]');

  if (nameEl) {
    nameEl.textContent = name;
  }

  if (emailEl) {
    emailEl.textContent = email;
  }

  if (roleEl) {
    roleEl.textContent = role;
  }
}

 async loadDashboard() {
  const dashboardPage =
    this.root.querySelector('[data-aa-dashboard]');

  if (!dashboardPage) {
    return;
  }

  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.playbookId || !window.AAPlaybookService) {
    const monthValue =
      this.root.querySelector('[data-aa-dashboard-month]');

    const statusValue =
      this.root.querySelector('[data-aa-dashboard-status]');

    const accessValue =
      this.root.querySelector('[data-aa-dashboard-access]');

    const actionButton =
      this.root.querySelector('[data-aa-dashboard-action]');

    const heroActionButton =
      this.root.querySelector('[data-aa-dashboard-hero-action]');

    const lastSavedLabel =
      this.root.querySelector('[data-aa-dashboard-last-saved-label]');

    const lastSavedMessage =
      this.root.querySelector('[data-aa-dashboard-last-saved-message]');

    const lastSavedValue =
      this.root.querySelector('[data-aa-dashboard-last-saved-value]');

    if (monthValue) {
      monthValue.textContent = 'No current Playbook';
    }

    if (statusValue) {
      statusValue.textContent = '—';
    }

    if (accessValue) {
      accessValue.textContent = '—';
    }

    if (actionButton) {
      actionButton.textContent = 'View Playbooks';
      actionButton.href = '/pages/workspace-previous-playbooks';
    }

    if (heroActionButton) {
      heroActionButton.textContent = 'View Playbooks';
      heroActionButton.href = '/pages/workspace-previous-playbooks';
    }

    if (lastSavedLabel) {
      lastSavedLabel.textContent = 'No Playbook Yet';
    }

    if (lastSavedMessage) {
      lastSavedMessage.textContent =
        'A Playbook has not been created for this client yet.';
    }

    if (lastSavedValue) {
      lastSavedValue.textContent = '—';
    }

    return;
  }

  const monthValue = this.root.querySelector('[data-aa-dashboard-month]');
  const statusValue = this.root.querySelector('[data-aa-dashboard-status]');
  const accessValue = this.root.querySelector('[data-aa-dashboard-access]');
const dueDateValue = this.root.querySelector('[data-aa-dashboard-due-date]');
const actionButton = this.root.querySelector('[data-aa-dashboard-action]');
  const heroActionButton = this.root.querySelector('[data-aa-dashboard-hero-action]');

  const nextMonthValue = this.root.querySelector('[data-aa-dashboard-next-month]');
  const nextStatusValue = this.root.querySelector('[data-aa-dashboard-next-status]');
  const nextMessageValue = this.root.querySelector('[data-aa-dashboard-next-message]');

  const accountStatusValue = this.root.querySelector('[data-aa-dashboard-account-status]');
  const invoiceStatusValue = this.root.querySelector('[data-aa-dashboard-invoice-status]');

  const lastSavedLabel = this.root.querySelector('[data-aa-dashboard-last-saved-label]');
const lastSavedMessage = this.root.querySelector('[data-aa-dashboard-last-saved-message]');
const lastSavedValue = this.root.querySelector('[data-aa-dashboard-last-saved-value]');
const activityTime = this.root.querySelector('[data-aa-dashboard-activity-time]');

const actionCenter =
  this.root.querySelector('[data-aa-dashboard-actions]');

const actionCount =
  this.root.querySelector('[data-aa-dashboard-action-count]');

const progressValue =
  this.root.querySelector('[data-aa-dashboard-progress]');

const progressBar =
  this.root.querySelector('[data-aa-dashboard-progress-bar]');

const progressPercent =
  this.root.querySelector('[data-aa-dashboard-progress-percent]');

const [
  dashboard,
  windowData,
  completion
] = await Promise.all([
  window.AAPlaybookService.getPlaybookDashboardById({
    playbookId: workspace.playbookId
  }),

  window.AAPlaybookService.getPlaybookWindow(
    workspace.clientId
  ),

  window.AAPlaybookService.getPlaybookCompletion({
    playbookId: workspace.playbookId
  })
]);

if (!dashboard) return;

  const playbook = dashboard.playbook;

  const primaryAction =
  window.AAPlaybookService.getPlaybookPrimaryAction(playbook);

const resolvedStatus = primaryAction.status;
const canEdit = primaryAction.editable;

const playbookIsComplete =
  completion.totalSections > 0 &&
  completion.completedSections >= completion.totalSections;

if (progressValue) {
  progressValue.textContent =
    `${completion.completedSections} of ${completion.totalSections} sections complete`;
}

if (progressBar) {
  progressBar.style.width =
    `${completion.percentage}%`;

  progressBar.setAttribute(
    'aria-valuenow',
    String(completion.percentage)
  );
}

if (progressPercent) {
  progressPercent.textContent =
    `${completion.percentage}%`;
}

if (monthValue) {
    monthValue.textContent =
      `${this.getMonthName(playbook.month)} ${playbook.year}`;
  }

  if (statusValue) {
    statusValue.classList.add('aa-status-pill');
    statusValue.dataset.status = resolvedStatus;
    statusValue.textContent =
      window.AAPlaybookService.formatPlaybookStatus(resolvedStatus);
  }

  if (accessValue) {
  accessValue.textContent = canEdit
    ? 'Editable'
    : 'Read Only';
}

const playbookDueDate = new Date(
  Number(playbook.year),
  Number(playbook.month) - 2,
  15,
  23,
  59,
  59,
  999
);

if (dueDateValue) {
  dueDateValue.textContent = playbookDueDate.toLocaleDateString(
    'en-US',
    {
      month: 'long',
      day: 'numeric'
    }
  );
}

if (actionCenter && actionCount) {
  const now = new Date();

const warningStartDate = new Date(
  Number(playbook.year),
  Number(playbook.month) - 2,
  10,
  0,
  0,
  0,
  0
);

const todayStart = new Date(
  now.getFullYear(),
  now.getMonth(),
  now.getDate()
);

const dueDayStart = new Date(
  playbookDueDate.getFullYear(),
  playbookDueDate.getMonth(),
  playbookDueDate.getDate()
);

const daysRemaining = Math.round(
  (dueDayStart.getTime() - todayStart.getTime()) /
  (1000 * 60 * 60 * 24)
);

const warningIsActive =
  now >= warningStartDate &&
  now <= playbookDueDate;

  if (
  canEdit &&
  !playbookIsComplete &&
  warningIsActive &&
  daysRemaining >= 0
) {
    actionCount.hidden = false;
    actionCount.textContent = '1';

    const deadlineLabel =
      daysRemaining === 0
        ? 'Due today'
        : daysRemaining === 1
          ? 'Due tomorrow'
          : `Due in ${daysRemaining} days`;

    actionCenter.innerHTML = `
      <a
        href="/pages/workspace-current-playbook"
        class="aa-dashboard-action-item"
      >
        <div class="aa-dashboard-action-item__body">
          <strong>September Playbook is due soon</strong>
          <p>
            Complete your Playbook by
            ${playbookDueDate.toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric'
            })}.
          </p>
        </div>

        <span class="aa-dashboard-action-item__meta">
          ${deadlineLabel}
        </span>
      </a>
    `;
  } else {
    actionCount.hidden = true;
    actionCount.textContent = '0';

    actionCenter.innerHTML = `
      <div class="aa-dashboard-empty-state">
        <div class="aa-dashboard-empty-state__content">
          <strong>You’re all caught up.</strong>
          <p>Nothing needs your attention right now.</p>
        </div>
      </div>
    `;
  }
}

  if (actionButton) {
  actionButton.textContent = primaryAction.shortLabel;
  actionButton.href = primaryAction.href;
}

if (heroActionButton) {
  heroActionButton.textContent = primaryAction.label;
  heroActionButton.href = primaryAction.href;
}

  const activityMonth =
  `${this.getMonthName(playbook.month)} Playbook`;

if (dashboard.lastSavedAt) {
  if (lastSavedLabel) {
    lastSavedLabel.textContent =
      `${activityMonth} updated`;
  }

  if (lastSavedMessage) {
    lastSavedMessage.textContent =
      'Changes were saved to your Playbook.';
  }

  if (activityTime) {
    activityTime.textContent =
      new Date(dashboard.lastSavedAt).toLocaleString(
        'en-US',
        {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        }
      );
  }
} else {
  if (lastSavedLabel) {
    lastSavedLabel.textContent =
      `${activityMonth} created`;
  }

  if (lastSavedMessage) {
    lastSavedMessage.textContent =
      'Your Playbook is ready for planning.';
  }

  if (activityTime) {
    activityTime.textContent = playbook.created_at
      ? new Date(playbook.created_at).toLocaleDateString(
          'en-US',
          {
            month: 'short',
            day: 'numeric'
          }
        )
      : '';
  }
}

  if (lastSavedValue) {
    lastSavedValue.textContent = dashboard.lastSavedAt
      ? new Date(dashboard.lastSavedAt).toLocaleString()
      : 'Not saved yet';
  }

  const nextPlaybook = windowData?.nextPlaybook || null;

  if (nextPlaybook) {

    if (nextMonthValue) {
      nextMonthValue.textContent =
        `${this.getMonthName(nextPlaybook.month)} ${nextPlaybook.year}`;
    }

    if (nextStatusValue) {
      nextStatusValue.textContent =
        window.AAPlaybookService.formatPlaybookStatus(
          window.AAPlaybookService.resolvePlaybookStatus(nextPlaybook)
        );
    }

    if (nextMessageValue) {
      nextMessageValue.textContent =
        'Your next scheduled Playbook is ready.';
    }

  } else {

    if (nextMonthValue) {
      nextMonthValue.textContent =
        'No upcoming Playbook';
    }

    if (nextStatusValue) {
      nextStatusValue.textContent = '—';
    }

    if (nextMessageValue) {
      nextMessageValue.textContent =
        'A future Playbook has not been created yet.';
    }

  }

  if (this.clientAccount) {

    if (accountStatusValue) {
      accountStatusValue.textContent =
        this.clientAccount.status || 'Active';
    }

    if (invoiceStatusValue) {
      invoiceStatusValue.textContent =
        this.clientAccount.invoice_status || 'Current';
    }

  }
}



  async loadAccount() {
    const accountPage = this.root.querySelector('[data-aa-account-page]');
    if (!accountPage || !window.AAPlaybookService) return;

    const workspace = window.AAWorkspaceContext.get();

   const account = this.clientAccount;

    const playbookResult =
  await window.AAPlaybookService.loadPlaybookById({
    playbookId: workspace.playbookId
  });

const playbook = playbookResult?.playbook;

const playbookStatus = playbook
  ? window.AAPlaybookService.resolvePlaybookStatus(playbook)
  : 'draft';

    const setText = (selector, value) => {
      const el = this.root.querySelector(selector);
      if (el) el.textContent = value || 'Not set';
    };


    setText('[data-aa-account-business-name]', account?.business_name || account?.client_name || 'Client Workspace');
    setText('[data-aa-account-client-id]', workspace.clientId);
    setText('[data-aa-account-playbook-id]', workspace.playbookId);
    setText('[data-aa-account-workspace-status]', 'Active');
    setText('[data-aa-account-playbook-month]', this.getMonthName(workspace.month) || workspace.month);
    setText('[data-aa-account-playbook-year]', workspace.year);
    setText(
      '[data-aa-account-playbook-status]',
      window.AAPlaybookService.formatPlaybookStatus(playbookStatus)
    );
    setText('[data-aa-account-status]', account?.status || 'Active');
    setText('[data-aa-account-invoice-status]', account?.invoice_status || 'Current');
  }
async loadMarketingPlan() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId || !window.AAPlaybookService) return;

  const card = this.root.querySelector('[data-aa-marketing-plan-card]');
  const titleValue = this.root.querySelector('[data-aa-marketing-plan-title]');
  const introValue = this.root.querySelector('[data-aa-marketing-plan-intro]');
  const statusValue = this.root.querySelector('[data-aa-marketing-plan-status]');
  const sectionsValue = this.root.querySelector('[data-aa-marketing-plan-sections]');
  const servicesValue = this.root.querySelector('[data-aa-marketing-plan-services]');

  if (!card) return;

  this.marketingPlan = await window.AAPlaybookService.getMarketingPlanByClient({
    clientId: workspace.clientId
  });

  const plan = this.marketingPlan?.plan || null;
  const sections = this.marketingPlan?.sections || [];
  const services = this.marketingPlan?.services || [];

  if (!plan) {
    if (titleValue) titleValue.textContent = 'Your Custom Marketing Plan';
    if (introValue) introValue.textContent = 'Your custom marketing plan has not been assigned yet.';
    if (statusValue) statusValue.textContent = 'Not assigned';
    if (sectionsValue) sectionsValue.textContent = '0';
    if (servicesValue) servicesValue.textContent = '0';
    return;
  }

  if (titleValue) {
    titleValue.textContent = plan.name || 'Your Custom Marketing Plan';
  }

  if (introValue) {
    introValue.textContent =
      plan.introText ||
      plan.intro_text ||
      'Your custom marketing plan is ready.';
  }

  if (statusValue) {
    statusValue.textContent = plan.status || 'Active';
  }

  if (sectionsValue) {
    sectionsValue.textContent = String(sections.length);
  }

  if (servicesValue) {
    servicesValue.textContent = String(services.length);
  }
}

async loadMarketingPackage() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId || !window.AAPlaybookService) return;

  const container = this.root.querySelector('[data-aa-marketing-package]');
  if (!container) return;

  this.marketingPackage =
    await window.AAPlaybookService.getClientMarketingPackage({
      clientId: workspace.clientId,
      month: workspace.month,
      year: workspace.year
    });

  const services = this.marketingPackage?.services || [];

  if (!services.length) {
    container.innerHTML = `
      <p>No marketing package has been assigned yet.</p>
    `;
    return;
  }

  container.innerHTML = services.map((service) => {
    const included = service.included || service.allowance || '—';
    const completed = service.completed || 0;
    const remaining = service.remaining ?? '—';
    const unit = service.unit || 'included';

    return `
      <div class="aa-headquarters__detail-row">
        <p><strong>${service.name}</strong></p>
        <p>Included: ${included} ${unit}</p>
        <p>Completed: ${completed} ${unit}</p>
        <p>Remaining: ${remaining} ${unit}</p>
      </div>
    `;
  }).join('');
}

async loadContractCenter() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId || !window.AAPlaybookService) return;

  const container = this.root.querySelector('[data-aa-contract-center]');
  if (!container) return;

  this.contracts =
    await window.AAPlaybookService.getClientContracts({
      clientId: workspace.clientId
    });

  const contracts = this.contracts || [];

  if (!contracts.length) {
    container.innerHTML = `
      <p>No contracts are currently available.</p>
    `;
    return;
  }

  const priority = {
    pending_signature: 1,
    active: 2,
    expired: 3
  };

  const sortedContracts = [...contracts].sort((a, b) => {
    return (priority[a.status] || 99) - (priority[b.status] || 99);
  });

  container.innerHTML = sortedContracts.map((contract) => {
    const status = this.formatContractStatus(contract.status);
    const effectiveDate = this.formatDate(contract.effectiveDate);
    const expirationDate = this.formatDate(contract.expirationDate);
    const renewalDate = this.formatDate(contract.renewalDate);
    const renewalOrExpiration = renewalDate || expirationDate || 'Not set';

    return `
      <div class="aa-headquarters__detail-row">

        <h4 class="aa-contract-title">
          ${contract.title || 'Contract'}
        </h4>

        <span
          class="aa-status-pill"
          data-status="${contract.status || 'inactive'}">
          ${status}
        </span>

        <p class="aa-contract-meta">
          ${contract.type || 'Contract'}
          <span>•</span>
          Version ${contract.version || 'Not set'}
        </p>

        <div class="aa-contract-dates">

          <div class="aa-contract-date">
            <small>Effective Date</small>
            <strong>${effectiveDate || 'Not set'}</strong>
          </div>

          <div class="aa-contract-date">
            <small>${renewalDate ? 'Renewal Date' : 'Expiration Date'}</small>
            <strong>${renewalOrExpiration}</strong>
          </div>

        </div>

        <div class="aa-contract-actions">
          <p>Actions coming soon</p>
        </div>

      </div>
    `;
  }).join('');
}

async loadBrandAssets() {
  const workspace = window.AAWorkspaceContext.get();

  if (!workspace?.clientId || !window.AAPlaybookService) return;

  const container = this.root.querySelector('[data-aa-brand-assets]');
  if (!container) return;

  this.brandAssets =
    await window.AAPlaybookService.getClientBrandAssets({
      clientId: workspace.clientId
    });

  const assets = this.brandAssets || [];

  if (!assets.length) {
    container.innerHTML = `
      <p>No brand assets have been uploaded yet.</p>
    `;
    return;
  }

  container.innerHTML = assets.map((asset) => {
    return `
      <div class="aa-headquarters__detail-row">
        <p><strong>${asset.title}</strong></p>
        <p>Type: ${asset.type}</p>
        <p>File: ${asset.fileName || 'Not available'}</p>
        <p>Uploaded: ${this.formatDate(asset.uploadedAt) || 'Not available'}</p>
        ${
          asset.description
            ? `<p>${asset.description}</p>`
            : ''
        }
      </div>
    `;
  }).join('');
}

formatContractStatus(status) {
  const labels = {
    active: 'Active Contract',
    pending_signature: 'Pending Signature',
    expired: 'Expired Contract'
  };

  return labels[status] || 'No Contracts Available';
}

formatDate(value) {
  if (!value) return '';

  return new Date(value).toLocaleDateString();
}

  async loadPreviousPlaybooks() {
    const container = this.root.querySelector('[data-aa-previous-playbooks]');

    if (!container || !window.AAPlaybookService) return;

    const workspace = window.AAWorkspaceContext.get();

    this.previousPlaybooks = await window.AAPlaybookService.getPlaybooksByClient({
      clientId: workspace.clientId
    });

    this.previousPlaybookSearch = '';
    this.previousPlaybookSort = 'newest';

    this.renderPreviousPlaybooksManager(container);
  }

  renderPreviousPlaybooksManager(container) {
    container.innerHTML = `
      ${this.renderManagementToolbar({
        searchValue: this.previousPlaybookSearch,
        sortValue: this.previousPlaybookSort,
        resultsCount: this.getFilteredPreviousPlaybooks().length
      })}
      <div data-aa-previous-playbooks-list></div>
    `;

    const searchInput = container.querySelector('[data-aa-management-search]');
    const sortSelect = container.querySelector('[data-aa-management-sort]');

    if (searchInput) {
      searchInput.addEventListener('input', (event) => {
        this.previousPlaybookSearch = event.target.value;
        this.renderPreviousPlaybooksList(container);
        this.updateManagementResultsCount(container);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', (event) => {
        this.previousPlaybookSort = event.target.value;
        this.renderPreviousPlaybooksList(container);
        this.updateManagementResultsCount(container);
      });
    }

    this.renderPreviousPlaybooksList(container);
  }

  renderManagementToolbar({ searchValue = '', sortValue = 'newest', resultsCount = 0 }) {
    return `
      <div class="aa-management-toolbar">
        <div class="aa-management-toolbar__search">
          <label for="aa-playbook-search">Search</label>
          <input
            id="aa-playbook-search"
            type="search"
            value="${searchValue}"
            placeholder="Search playbooks"
            data-aa-management-search
          >
        </div>

        <div class="aa-management-toolbar__sort">
          <label for="aa-playbook-sort">Sort</label>
          <select id="aa-playbook-sort" data-aa-management-sort>
            <option value="newest" ${sortValue === 'newest' ? 'selected' : ''}>Newest First</option>
            <option value="oldest" ${sortValue === 'oldest' ? 'selected' : ''}>Oldest First</option>
            <option value="status" ${sortValue === 'status' ? 'selected' : ''}>Status</option>
            <option value="month" ${sortValue === 'month' ? 'selected' : ''}>Month</option>
          </select>
        </div>

        <p class="aa-management-toolbar__count" data-aa-management-results-count>
          ${resultsCount} result${resultsCount === 1 ? '' : 's'}
        </p>
      </div>
    `;
  }

  renderPreviousPlaybooksList(container) {
    const list = container.querySelector('[data-aa-previous-playbooks-list]');
    if (!list) return;

    const playbooks = this.getFilteredPreviousPlaybooks();

    if (!playbooks.length) {
      list.innerHTML = `
        <article class="aa-card">
          <h3>No playbooks match your search.</h3>
        </article>
      `;
      return;
    }

    list.innerHTML = playbooks.map((playbook) => {
      const title = `${this.getMonthName(playbook.month)} ${playbook.year}`;
      const primaryAction =
  window.AAPlaybookService.getPlaybookPrimaryAction(playbook);

const status = primaryAction.status;
const statusLabel = window.AAPlaybookService.formatPlaybookStatus(status);

      return `
        <article class="aa-card">
          <span class="aa-status-pill" data-status="${status}">
            ${statusLabel}
          </span>

          <h3>${title}</h3>

          <p><strong>Status:</strong> ${statusLabel}</p>
          <p><strong>Last Saved:</strong> ${
            playbook.updated_at
              ? new Date(playbook.updated_at).toLocaleString()
              : 'Not saved yet'
          }</p>

          ${
            playbook.workspace_type
              ? `<p><strong>Workspace Type:</strong> ${playbook.workspace_type}</p>`
              : ''
          }

          <a class="aa-button aa-button--primary" href="${primaryAction.href}">
  ${primaryAction.label}
</a>
        </article>
      `;
    }).join('');
  }

  getFilteredPreviousPlaybooks() {
    const search = (this.previousPlaybookSearch || '').toLowerCase().trim();

    let playbooks = [...(this.previousPlaybooks || [])];

    if (search) {
      playbooks = playbooks.filter((playbook) => {
        const status = playbook.status || 'draft';
        const statusLabel = window.AAPlaybookService.formatPlaybookStatus(status);

        return [
          this.getMonthName(playbook.month),
          playbook.year,
          status,
          statusLabel
        ].join(' ').toLowerCase().includes(search);
      });
    }

    playbooks.sort((a, b) => {
      if (this.previousPlaybookSort === 'oldest') {
        return this.getPlaybookDateValue(a) - this.getPlaybookDateValue(b);
      }

      if (this.previousPlaybookSort === 'status') {
  return window.AAPlaybookService
    .formatPlaybookStatus(a.status || 'draft')
    .localeCompare(
      window.AAPlaybookService.formatPlaybookStatus(b.status || 'draft')
    );
}

      if (this.previousPlaybookSort === 'month') {
        return Number(a.month || 0) - Number(b.month || 0);
      }

      return this.getPlaybookDateValue(b) - this.getPlaybookDateValue(a);
    });

    return playbooks;
  }

  getLatestPlaybook() {
    const playbooks = [...(this.previousPlaybooks || [])];

    if (!playbooks.length) {
      const workspace = window.AAWorkspaceContext.get();

      return {
        month: workspace.month,
        year: workspace.year
      };
    }

    playbooks.sort((a, b) => this.getPlaybookDateValue(b) - this.getPlaybookDateValue(a));

    return playbooks[0];
  }

  getPlaybookDateValue(playbook) {
    return Number(`${playbook.year || 0}${String(playbook.month || 0).padStart(2, '0')}`);
  }

  updateManagementResultsCount(container) {
    const count = container.querySelector('[data-aa-management-results-count]');
    if (!count) return;

    const resultsCount = this.getFilteredPreviousPlaybooks().length;

    count.textContent = `${resultsCount} result${resultsCount === 1 ? '' : 's'}`;
  }

  getMonthName(month) {
    const monthNames = [
      '',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    return monthNames[month] || month;
  }

  bindEvents() {
    this.root.addEventListener('click', (event) => {
      const link = event.target.closest(
        'a[href^="/pages/workspace-"]'
      );

      if (!link) return;

      const workspace =
        window.AAWorkspaceContext?.get?.();

      const adminClientId =
        workspace?.isInternal
          ? window.AAAdminWorkspaceView?.getClientId?.()
          : null;

      if (!adminClientId) return;

      const url = new URL(
        link.href,
        window.location.origin
      );

      url.searchParams.set(
        'aa_admin_client',
        adminClientId
      );

      link.href =
        `${url.pathname}${url.search}${url.hash}`;
    });

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.openSidebar());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeSidebar());
    }

    const signOutButton =
      this.root.querySelector('[data-aa-workspace-sign-out]');

    if (signOutButton) {
      signOutButton.addEventListener('click', async () => {
        signOutButton.disabled = true;

        try {
          await window.AAWorkspaceContext?.signOut?.();
        } catch (error) {
          console.error('Unable to sign out.', error);
          signOutButton.disabled = false;
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeSidebar();
    });
  }

  bindCreatePlaybook() {
    const button = this.root.querySelector('[data-aa-create-playbook]');

    if (!button) return;

    button.addEventListener('click', () => {
      this.handleCreatePlaybook(button);
    });
  }

  async handleCreatePlaybook(button) {
    if (!button || !window.AAPlaybookService) return;

    const workspace = window.AAWorkspaceContext.get();
    const latestPlaybook = this.getLatestPlaybook();

    const nextPlaybookDate = window.AAPlaybookService.getNextPlaybookMonth({
      month: latestPlaybook.month,
      year: latestPlaybook.year
    });

    if (!nextPlaybookDate) return;

    button.disabled = true;
    button.textContent = 'Creating...';

    const result = await window.AAPlaybookService.createPlaybook({
      clientId: workspace.clientId,
      month: nextPlaybookDate.month,
      year: nextPlaybookDate.year
    });

    if (result?.success) {
      button.textContent =
        result.reason === 'already_exists'
          ? "This month's Playbook already exists."
          : 'Playbook created successfully.';

      await this.loadDashboard();
      await this.loadPreviousPlaybooks();
    } else {
      button.textContent = 'Unable to create Playbook. Please try again.';
    }

    setTimeout(() => {
      button.disabled = false;
      button.textContent = 'Create Next Playbook';
    }, 2500);
  }

  openSidebar() {
    this.root.classList.add('is-sidebar-open');
  }

  closeSidebar() {
    this.root.classList.remove('is-sidebar-open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-aa-workspace]').forEach((workspace) => {
    new AAWorkspaceShell(workspace);
  });
});

class AAPlaybook {
  constructor(root) {
    this.root = root;
    this.cards = root.querySelectorAll('.aa-section-card');

    this.bindEvents();
  }

  bindEvents() {
    this.cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        const link = event.target.closest('a');

        if (!link) {
          const cardLink = card.querySelector('a');
          if (cardLink) cardLink.click();
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aa-playbook').forEach((playbook) => {
    new AAPlaybook(playbook);
  });
});
